import React from "react";
import { useHistory } from "react-router";
import styles from "./PrimaryBuyers.module.sass";

const Row = ({ item }) => {
	const history = useHistory();
	return (
		<div
			className={styles.row}
			onClick={() => {
				history.push(`/customers/list/customer/` + item.user?._id);
			}}
		>
			<div className={styles.col}>{item.user?.userName}</div>
			<div className={styles.col}>{item.user?.email}</div>
			<div className={styles.col}>
				{new Date(item.createdAt).toLocaleString()}
			</div>
		</div>
	);
};

export default Row;
